import { FormControl, FormHelperText, InputLabel, MenuItem, OutlinedInput, Select, SelectProps, SelectChangeEvent } from '@mui/material';
import _times from 'lodash/times';
import { nanoid } from 'nanoid/non-secure';
import React, { useCallback, useMemo } from 'react';
import type { IntInputFieldProps } from '../types';
type RenderOption = (i: number) => React.ReactNode;
const DEFAULT_RENDER_OPTION: RenderOption = i => i;
export type SelectIntProps = IntInputFieldProps & {
  min: number;
  max: number;
  renderOption?: RenderOption;
  label?: React.ReactNode | string;
  fullWidth?: boolean;
  size?: SelectProps['size'];
};
const DISABLE_PORTAL_MENU_PROPS = {
  disablePortal: true
};
const SelectInt: React.FC<SelectIntProps> = function (props) {
  const {
    name,
    value,
    setValue,
    min = 1,
    max = 999,
    required,
    label,
    autoComplete,
    errors,
    disabled,
    hint,
    fullWidth = true,
    renderOption = DEFAULT_RENDER_OPTION,
    size
  } = props;
  const id = useMemo(() => props.id ?? nanoid(), [props.id]);
  const handleChange = useCallback((event: SelectChangeEvent<number>) => {
    const newValue = event.target.value as number;
    setValue?.(newValue);
  }, [setValue]);
  return <FormControl size={size} error={errors?.length > 0} disabled={disabled} fullWidth={fullWidth} required={required}>
      {label && <InputLabel id={id + '-label'} htmlFor={id}>
          {label}
        </InputLabel>}
      <Select id={id} labelId={id + '-label'} input={<OutlinedInput label={label} />} name={name} label={label} required={required} autoComplete={autoComplete} disabled={disabled} onChange={handleChange} value={value ?? ''} MenuProps={DISABLE_PORTAL_MENU_PROPS} size={size}>
        {_times(max - min + 1, index => {
        return <MenuItem key={index + min} value={index + min}>
              {renderOption(index + min)}
            </MenuItem>;
      })}
      </Select>
      <FormHelperText className={errors?.length > 0 ? 'NiaraErrorDescription' : undefined}>
        {errors?.length > 0 ? errors.join(', ') : hint}
      </FormHelperText>
    </FormControl>;
};
export default SelectInt;